// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"453af834","18":"626568e7","122":"101d92ed","136":"1794a458","312":"b65fc49a","912":"1d405f3c","961":"ecbec1b8"}[chunkId] + ".chunk.css";
};